import "./style.css";

/**
 * `handleBlur` et `onKeyDown` sont déstructurés pour être posés sur le champ lui-même :
 * le reste des props est étalé sur le conteneur, où un gestionnaire de saisie n'aurait
 * pas sa place. Les deux sont facultatifs, les usages existants ne changent pas.
 */
const InputReverto = ({ label = "", handleChange, handleBlur = null, onKeyDown = null, ...props }) => {
    const {
        id,
        disabled = false,
        type = "text",
        value,
        placeholder = "",
    } = props;
    return (
        <div className="container-input" {...props}>
            {label !== "" ? <span className="label-input">{label}</span> : null}
            <input
                id={id}
                className="textfield-reverto"
                type={type}
                disabled={disabled}
                value={value}
                placeholder={placeholder}
                autoComplete={type === "password" ? "new-password" : "off"}
                onChange={(event) => handleChange(event)}
                onBlur={handleBlur ? (event) => handleBlur(event) : undefined}
                onKeyDown={onKeyDown ? (event) => onKeyDown(event) : undefined}
            />
        </div>
    );
};

export default InputReverto;
